import { createReducer, on } from '@ngrx/store';
import { PartnerState } from '@interfaces/state_interfaces';
import * as PartnerActions from '../actions/rtmap.actions';

const initialPartnerState: PartnerState = {
    totalPartners: 0,
    totalActivePartners: 0,
    totalInactivePartners: 0,
    loading: false,
    error: null
}; 

export const partnerReducer = createReducer(
    initialPartnerState,
    
    // Load Stats
    on(PartnerActions.loadPartnerStats, (state) => ({
        ...state,
        loading: true,
        error: null
    })),
    
    on(PartnerActions.loadPartnerStatsSuccess, (state, { totalPartners, totalActivePartners, totalInactivePartners }) => ({
        ...state,
        totalPartners,
        totalActivePartners,
        totalInactivePartners,
        loading: false,
        error: null
    })),
    
    on(PartnerActions.loadPartnerStatsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        error
    })),

    // Individual Updates
    on(PartnerActions.updateTotalPartners, (state, { total }) => ({
        ...state,
        totalPartners: total
    })),
    
    on(PartnerActions.updateActivePartners, (state, { total }) => ({
        ...state,
        totalActivePartners: total
    })),
    
    on(PartnerActions.updateInactivePartners, (state, { total }) => ({
        ...state,
        totalInactivePartners: total
    }))
); 